import React, { useState } from 'react';

const FAQsPage = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "What is IT Asset Disposition (ITAD)?",
      answer: "IT Asset Disposition (ITAD) is the process of securely disposing of, recycling, or remarketing IT equipment at the end of its useful life. This includes secure data destruction, asset recovery, and environmentally responsible recycling of computers, servers, and other electronic devices."
    },
    {
      id: 2,
      question: "How do you ensure data security during the disposal process?",
      answer: "We follow strict data destruction protocols including NIST 800-88, HIPAA, and GDPR compliance. Our process includes certified data erasure, physical destruction when necessary, and provides certificates of destruction for all processed devices."
    },
    {
      id: 3,
      question: "What types of IT equipment do you accept?",
      answer: "We accept a wide range of IT equipment including laptops, desktops, servers, LCD monitors, smartphones, tablets, networking equipment, and other electronic devices. We also handle secure document destruction and provide trade-in programs for various devices."
    },
    {
      id: 4,
      question: "Do you offer on-site services?",
      answer: "Yes, we offer both on-site and off-site services across the United States. Our on-site services include secure data destruction, asset collection, and immediate processing to ensure maximum security and convenience for our clients."
    },
    {
      id: 5,
      question: "What certifications do you hold?",
      answer: "We are certified under R2 (Responsible Recycling) and e-Stewards standards, ensuring environmentally responsible recycling practices. We also maintain compliance with HIPAA, GDPR, and NIST 800-88 protocols for data security."
    },
    {
      id: 6,
      question: "How do you determine the value of my IT assets?",
      answer: "We evaluate devices based on condition, functionality, age, and market demand. Our grading system (A, B, C, D) provides transparent pricing with no hidden fees. We provide high-quality images and detailed assessments for every device."
    },
    {
      id: 7,
      question: "What happens to devices that can't be resold?",
      answer: "Devices that cannot be resold are responsibly recycled following R2 and e-Stewards standards. We ensure that all materials are properly processed to minimize environmental impact and comply with all regulations."
    },
    {
      id: 8,
      question: "How long does the disposal process take?",
      answer: "The timeline varies depending on the volume and type of equipment. Typically, we can process small batches within 1-2 business days, while larger projects may take 1-2 weeks. We provide detailed timelines during the initial consultation."
    },
    {
      id: 9,
      question: "Do you provide documentation for compliance purposes?",
      answer: "Yes, we provide comprehensive documentation including certificates of data destruction, recycling certificates, and detailed reports for compliance with environmental and data protection regulations."
    },
    {
      id: 10,
      question: "What are the environmental benefits of your services?",
      answer: "Our services help reduce e-waste by extending the life of devices through remarketing and ensuring responsible recycling. We've helped clients reduce their electronic waste by more than 50% annually while supporting sustainability goals."
    }
  ];

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <main className="fq">
      <div className="container">
      <section className="sv-hero">
        <div className="sv-eyebrow">FAQs</div>
        <h1 className="sv-title">Enterprise IT Asset Disposition FAQs</h1>
        <p className="sv-subtitle">Answers about data security, compliance, documentation, and recovery value in your IT lifecycle.</p>
        <img className="sv-hero-img" src="/faqs.png" alt="Frequently asked questions" />
      </section>

        <section className="fq-methodology">
          <h2 className="sv-section-title">Data Security Methodology</h2>
          <div className="fq-cards">
            <div className="fq-card">
              <h3>Physical Asset Security</h3>
              <p>Tamper‑evident packaging, GPS‑tracked transport, and secure facilities with biometric access controls.</p>
            </div>
            <div className="fq-card">
              <h3>Data Sanitization</h3>
              <p>Three‑pass destruction exceeding DoD 5220.22‑M with verification scans and certified fallbacks.</p>
            </div>
            <div className="fq-card">
              <h3>Verification Documentation</h3>
              <p>Per‑asset certificates with timestamps, technician IDs, and immutable records for audit defense.</p>
            </div>
          </div>
        </section>

        <section className="fq-compliance">
          <h2 className="sv-section-title">Compliance & Certifications</h2>
          <ul className="sv-bullets">
            <li>GDPR, HIPAA, R2v3, e‑Stewards alignment</li>
            <li>Chain‑of‑custody with serialized tracking</li>
            <li>Environmental reporting and zero‑landfill commitment</li>
          </ul>
        </section>

        <section className="fq-content">
          <div className="fq-list">
            {faqs.map((faq) => (
              <div key={faq.id} className="fq-item">
                <button
                  className={`fq-q ${openFAQ === faq.id ? 'open' : ''}`}
                  onClick={() => toggleFAQ(faq.id)}
                  aria-expanded={openFAQ === faq.id}
                >
                  <span>{faq.question}</span>
                  <span className="fq-icon" aria-hidden="true">
                    {openFAQ === faq.id ? '−' : '+'}
                  </span>
                </button>
                {openFAQ === faq.id && (
                  <div className="fq-a">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>

        <section className="fq-cta">
          <div className="sv-cta-inner">
            <h3>Need more detail for compliance review?</h3>
            <p>Request sample certificates and methodology documentation tailored to your industry.</p>
            <div className="sv-cta-actions">
              <a href="tel:+18778739336" className="btn btn-primary">Call (877) 873‑9336</a>
              <a href="mailto:info@globoflo.com" className="btn btn-secondary">Email Us</a>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default FAQsPage;
